import { SC } from "../helper/ServerCall";

export const musicServices = {
    getAllMusic
}

function getAllMusic() {
    return SC.getCall(`music`);
}